// Shopify ↔ React bridge — clés hardcodées (thème custom)
window.SS_URLS = window.SS_URLS || {
  product: '/products/livre-stick-stories',
  create:  '/products/livre-stick-stories',
  cart:    '/cart',
  home:    '/',
  about:   '/pages/qui-sommes-nous',
  login:   '/pages/connexion',
  track:   '/pages/suivre-mon-colis',
  contact: '/pages/contact'
};

window.SS_SLOT_SRCS  = window.SS_SLOT_SRCS  || {};
window.SS_PDF_ASSETS = window.SS_PDF_ASSETS || {};
window.SS_LOGO_SRCS  = window.SS_LOGO_SRCS  || {};
window.SS_COVER_SRCS = window.SS_COVER_SRCS || {};

if (!window.SS_SHOPIFY) window.SS_SHOPIFY = {};

// Storefront API — Headless channel public token
if (!window.SS_SHOPIFY.storefrontToken)
  window.SS_SHOPIFY.storefrontToken = 'dc39f05dcd36b3342cb72351a53bc38a';

// Web3Forms — formulaire contact
if (!window.SS_SHOPIFY.web3formsKey)
  window.SS_SHOPIFY.web3formsKey = '82198fc7-8217-404a-96e8-d28351d9e8b6';

// Google OAuth — connexion Google
if (!window.SS_SHOPIFY.googleClientId)
  window.SS_SHOPIFY.googleClientId = '94065426836-ucrd0utklvt9q1p8r11450c14lvlu1q8.apps.googleusercontent.com';

// ── Cloudinary — hébergement photos (gratuit 25 Go, fiable, rapide) ──────
// Solution principale. Pour l'activer (3 minutes, gratuit, sans carte) :
//   1. Crée un compte sur https://cloudinary.com → note ton "Cloud name"
//      (visible sur le dashboard, ex. "dxy123abc").
//   2. Settings (roue crantée) → Upload → "Add upload preset" :
//        - Signing Mode : Unsigned
//        - (option) Folder : stick-stories
//      → note le nom du preset (ex. "stick_stories_unsigned").
//   3. Colle les deux valeurs ci-dessous. Tant qu'elles sont vides, on
//      retombe automatiquement sur ImgBB.
if (!window.SS_SHOPIFY.cloudinaryCloud)
  window.SS_SHOPIFY.cloudinaryCloud = 'djmrs7buh';
if (!window.SS_SHOPIFY.cloudinaryPreset)
  window.SS_SHOPIFY.cloudinaryPreset = 'stick_stories';

// ImgBB — secours si Cloudinary n'est pas configuré (https://imgbb.com → API)
if (!window.SS_SHOPIFY.imgbbKey)
  window.SS_SHOPIFY.imgbbKey = 'd78547b94c7b0391a4662264ca9255b2';

// Admin — mot de passe de la page /pages/admin-commandes
if (!window.SS_SHOPIFY.adminPassword)
  window.SS_SHOPIFY.adminPassword = 'stickstories2026';

// Texte personnalisé — product ID 15625817260358 (le variant ID est résolu automatiquement)
if (!window.SS_SHOPIFY.textUpsellProductId)
  window.SS_SHOPIFY.textUpsellProductId = '15625817260358';

// ── Résolution automatique du variant ID pour le texte upsell ────────────
window.ssResolveUpsellVariant = async function() {
  // Return cached variant ID if already resolved
  if (window.SS_SHOPIFY._textUpsellVariantId) return window.SS_SHOPIFY._textUpsellVariantId;
  const productId = window.SS_SHOPIFY && window.SS_SHOPIFY.textUpsellProductId;
  const token = window.SS_SHOPIFY && window.SS_SHOPIFY.storefrontToken;
  if (!productId || !token) return null;
  try {
    const gid = 'gid://shopify/Product/' + productId;
    const res = await fetch('/api/2024-01/graphql.json', {
      method: 'POST',
      headers: { 'X-Shopify-Storefront-Access-Token': token, 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: '{ node(id: "' + gid + '") { ... on Product { variants(first: 1) { edges { node { id } } } } } }' })
    });
    const json = await res.json();
    const varGid = json && json.data && json.data.node && json.data.node.variants && json.data.node.variants.edges[0] && json.data.node.variants.edges[0].node.id;
    if (varGid) {
      const numId = varGid.split('/').pop();
      window.SS_SHOPIFY._textUpsellVariantId = numId; // cache for this session
      return numId;
    }
  } catch(e) {}
  return null;
};

// ── Notification email propriétaire (désactivé — tout passe par Shopify) ─
window.ssNotifyOwner = async function(order) {
  const key = window.SS_SHOPIFY && window.SS_SHOPIFY.web3formsKey;
  if (!key) return;

  // Build admin link (all data in URL param so owner can open it directly)
  const encoded = btoa(unescape(encodeURIComponent(JSON.stringify(order))));
  const adminUrl = window.location.origin + '/pages/admin-commandes?d=' + encoded;

  // ── Photo gallery HTML for email ──
  const photoBlock = (label, url) => {
    if (!url || url === '—') return '';
    return '<div style="display:inline-block;margin:4px;text-align:center;font-size:11px;color:#555">'
      + '<a href="' + url + '" target="_blank">'
      + '<img src="' + url + '" width="90" height="90" style="object-fit:cover;border-radius:6px;border:1px solid #ddd"/>'
      + '</a><br/>' + label + '</div>';
  };

  let photosHtml = '<p><strong>Couverture :</strong><br/>' + photoBlock('Couverture', order.photos.couverture) + '</p>';
  const dos = order.photos.dos || [];
  const dosHtml = dos.map((u,i) => photoBlock('Dos ' + (i+1), u)).join('');
  if (dosHtml) photosHtml += '<p><strong>Dos :</strong><br/>' + dosHtml + '</p>';

  (order.categories || []).forEach((cat) => {
    const urls = order.photos[cat] || [];
    const catHtml = urls.map((u, i) => photoBlock(cat + ' ' + (i+1), u)).join('');
    if (catHtml) photosHtml += '<p><strong>' + cat + ' :</strong><br/>' + catHtml + '</p>';
  });

  const body = [
    '<h2 style="color:#c0392b">Nouvelle commande Stick Stories</h2>',
    '<p><strong>Date :</strong> ' + new Date(order.date).toLocaleString('fr-FR') + '</p>',
    '<p><strong>Édition :</strong> ' + order.edition + '</p>',
    '<p><strong>Coloris :</strong> ' + order.coloris + '</p>',
    '<p><strong>Titre :</strong> ' + order.titre + '</p>',
    '<p><strong>Prénom(s) :</strong> ' + (order.prenoms || '—') + '</p>',
    '<p><strong>Texte personnalisé :</strong> ' + (order.textUpsell ? 'Oui (+5 €)' : 'Non') + '</p>',
    '<p><strong>Catégories (' + (order.catCount || (order.categories || []).length) + ') :</strong> ' + (order.categories || []).join(', ') + '</p>',
    order.textUpsell && order.catTexts && Object.keys(order.catTexts).length > 0
      ? '<table style="border-collapse:collapse;width:100%;margin:8px 0 16px">'
        + (order.categories || []).map(cat => {
            const txt = (order.catTexts || {})[cat];
            if (!txt) return '';
            return '<tr><td style="padding:6px 10px;border:1px solid #eee;font-size:13px;color:#888;width:35%">' + cat + '</td>'
              + '<td style="padding:6px 10px;border:1px solid #eee;font-size:13px;color:#222">"' + txt + '"</td></tr>';
          }).join('')
        + '</table>'
      : '',
    '<hr/>',
    photosHtml,
    '<hr/>',
    '<p><a href="' + adminUrl + '" style="background:#c0392b;color:#fff;padding:10px 20px;border-radius:6px;text-decoration:none;font-weight:bold">Voir la commande complète →</a></p>',
    '<p style="font-size:11px;color:#999">Lien valide uniquement si connecté. Mot de passe requis.</p>'
  ].join('');

  const fd = new FormData();
  fd.append('access_key', key);
  fd.append('subject', 'Nouvelle commande Stick Stories — ' + order.edition + ' · ' + order.coloris);
  fd.append('from_name', 'Stick Stories');
  fd.append('html', body);
  fd.append('botcheck', '');

  await fetch('https://api.web3forms.com/submit', { method: 'POST', body: fd });
};
